/**
 * Convert date string to user's local time and format.
 * @param value Date string in ISO format.
 * @returns String version of date converted to user's local time.
 */
export const formatIsoDate = (value?: Date | string, includeTime = true) => {
  if (!value) return '';

  return includeTime ? new Date(value).toLocaleString() : new Date(value).toLocaleDateString();
};
